module.exports = __webpack_public_path__ + "img/what-we-sell_0008.a3b48305.jpg";